import dayjs from 'dayjs';
import advancedFormat from 'dayjs/plugin/advancedFormat';

dayjs.extend(advancedFormat);

const billingDateContent = (deferredProductBillDate, isAnnual, formatDayOfMonth, formatMonth) => {
  if (!deferredProductBillDate) {
    return null;
  }
  if (isAnnual) {
    return `${formatDayOfMonth(deferredProductBillDate)} of ${formatMonth(deferredProductBillDate)} each year`;
  }
  return `${formatDayOfMonth(deferredProductBillDate)} of each month`;
};

const nextPaymentContent = (
  isAnnual,
  deferredProductPrice,
  deferredProductBillDate,
  annualNextPaymentDate,
  formatDayOfMonth,
  formatMonth
) => {
  if (isAnnual) {
    return `£${deferredProductPrice} on ${annualNextPaymentDate().format('Do [of] MMMM YYYY')}`;
  }
  if (!deferredProductBillDate) {
    return null;
  }
  return `£${deferredProductPrice} on ${formatDayOfMonth(deferredProductBillDate)} of ${formatMonth(
    deferredProductBillDate
  )}`;
};

const getSubscriptionDetails = (
  nextBillingDate,
  currentPrice,
  deferredProductBillDate,
  hasDeferredBreachProduct,
  deferredProductPrice,
  isBreachUser,
  billing,
  basicToBreach,
  isAnnual = false
) => {
  const formatLongDate = date => dayjs(date).format('DD MMMM YYYY');
  const formatDayOfMonth = date => dayjs(date).format('Do');
  const formatMonth = date => dayjs(date).format('MMMM');
  const annualNextPaymentDate = () => {
    const backendDate = dayjs(deferredProductBillDate);
    return backendDate.isValid() ? backendDate.add(1, 'year') : dayjs().add(1, 'year');
  };

  let nextPayment = '';
  let billingDay = '';

  nextPayment = dayjs(nextBillingDate).isValid() ? `${currentPrice} on ${formatLongDate(nextBillingDate)}` : null;
  billingDay = dayjs(nextBillingDate).isValid() ? `${formatDayOfMonth(nextBillingDate)} of each month` : null;

  let subscriptionDetails;

  if (hasDeferredBreachProduct) {
    subscriptionDetails = [
      {
        content: deferredProductPrice ? `£${deferredProductPrice}` : null,
        id: deferredProductPrice ? 'subPrice' : null,
        label: deferredProductPrice ? 'Price' : null,
      },
      {
        content: billingDateContent(deferredProductBillDate, isAnnual, formatDayOfMonth, formatMonth),
        id: deferredProductBillDate ? 'subEndDate' : null,
        label: deferredProductBillDate ? 'Your billing date' : null,
      },
      {
        content: nextPaymentContent(
          isAnnual,
          deferredProductPrice,
          deferredProductBillDate,
          annualNextPaymentDate,
          formatDayOfMonth,
          formatMonth
        ),
        id: deferredProductBillDate ? 'subNextPayment' : null,
        label: deferredProductBillDate ? 'Next payment' : null,
      },
    ];
  } else if (!hasDeferredBreachProduct && isBreachUser) {
    subscriptionDetails = [
      {
        content: '£0.00',
        id: currentPrice ? 'subPrice' : null,
        label: currentPrice ? 'Price' : null,
      },
      {
        content: billing.endDate ? `${formatLongDate(billing.endDate)}` : null,
        id: billing.endDate ? 'subEndDate' : null,
        label: billing.endDate ? 'Subscription expires' : null,
      },
    ];
  } else if (!isBreachUser && !basicToBreach) {
    subscriptionDetails = [
      {
        content: currentPrice,
        id: currentPrice ? 'subPrice' : null,
        label: currentPrice ? 'Price' : null,
      },
      {
        content: billingDay,
        id: billingDay ? 'subBillingDate' : null,
        label: billingDay ? 'Your billing date' : null,
      },
      {
        content: nextPayment,
        id: nextPayment ? 'subNextPayment' : null,
        label: nextPayment ? 'Next payment' : null,
      },
    ];
  } else {
    subscriptionDetails = [
      {
        content: '£0.00',
        id: currentPrice ? 'subPrice' : null,
        label: currentPrice ? 'Price' : null,
      },
      {
        content: nextBillingDate ? `${formatLongDate(nextBillingDate)}` : null,
        id: nextBillingDate ? 'subEndDate' : null,
        label: nextBillingDate ? 'Subscription expires' : null,
      },
    ];
  }

  return subscriptionDetails;
};

export default getSubscriptionDetails;
